import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import jsPDF from 'jspdf'; //will insert the generated image into a PDF file
import html2canvas from 'html2canvas'; // will convert our HTML document to image
import {
  Icon,
  Modal,
  //Progress,
  //Segment,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import Loader from '../Loader/Loader';
import WithRouter from './WithRouter';

class ClarityReport extends Component {
  constructor(props) {
    super(props);
    this.isExporting = false;
    this.state = {
      refElement: props.refElement,
      //creatingProgress: 0,
      //isRendering: props.isRendering || null,
      //isRenderListOnly: props.isRenderListOnly || null,
      //isRenderProjectView: props.isRenderProjectView || null,
      viewMode: props.viewMode,
      isOpenLoader: false,
    };
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.createPdfWithCardView = this.createPdfWithCardView.bind(this);
    this.createPdfProjectView = this.createPdfProjectView.bind(this);
    this.createPdf = this.createPdf.bind(this);
    //this.setProgress = this.setProgress.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      viewMode, isRendering, isRenderListOnly, isRenderProjectView, refElement
    } = this.props;

    if (prevProps.viewMode !== viewMode) {
      this.setState({
        viewMode,
      });
    }

    if (prevProps.isRendering !== isRendering) {
      if (isRendering) {
        this.setState({
          refElement,
        }, () => {
          this.createPdf();
        });
      }
    }

    if (prevProps.isRenderProjectView !== isRenderProjectView) {
      if (isRenderProjectView) {
        this.setState({
          refElement,
        }, () => {
          this.createPdfProjectView();
        });
      }
    }

    if (prevProps.isRenderListOnly !== isRenderListOnly) {
      if (isRenderListOnly) {
        this.setState({
          refElement,
        }, () => {
          this.createPdfWithListOnly();
        });
      }
    }

  }

  /*
  setProgress(progress) {
    this.setState({
      creatingProgress: progress,
    });
  }
*/
  createElementWithCanvas = () => {
    const { createElementWithCanvas } = this.props;
    createElementWithCanvas();
  };

  createPdfWithCardView = () => {
    const { refElement } = this.state;
    const { generatePdfCallback } = this.props;
    const pageBreakEl = refElement.getElementsByClassName('page-break');

    if (pageBreakEl.length > 0) {
      let i = 0;
      for (i; i < pageBreakEl.length; i++) {
        const pad = this.createElement('div', {
          style: {
            display: 'block',
            height: '200px', //200px
            width: '100%',
            float: 'left',
          }
        });
        pageBreakEl[i].parentNode.insertBefore(pad, pageBreakEl[i].nextSibling);
      }
    }

    //chartjs-render-monitor

    this.isExporting = true;
    html2canvas(refElement, { x: 0, y: 0, allowTaint: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        //const elementTop = refElementClientRect.top;

        if (pageBreakEl.length === 0) {
          return this.createSmallPdf(imgData, canvas);
        }

        // eslint-disable-next-line new-cap
        const pdf = new jsPDF({ orientation: 'landscape' });
        const imgWidth = pdf.internal.pageSize.getWidth();

        //const clientRect = pageBreakEl[0].getBoundingClientRect();
        //const currentImgHeight = clientRect.bottom - elementTop;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // total image height
        const pageHeight = 210;

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        if (heightLeft >= 0) {
          let i = 1;
          for (i; i < pageBreakEl.length; i++) {
            const prevElementClientRect = pageBreakEl[i - 1].getBoundingClientRect();
            const currentElementClientRect = pageBreakEl[i].getBoundingClientRect();
            const pageBreakElImageHeight = currentElementClientRect.bottom - prevElementClientRect.bottom;
            const pageBreakElPageHeight = (pageBreakElImageHeight * imgHeight) / canvas.height;

            position = heightLeft - imgHeight;

            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageBreakElPageHeight;
          }
        }

        if (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        }

        this.setState({
          isOpenLoader: false,
        }, () => {
          pdf.save(`${moment().format('_YYMMDD_HHmm')}.pdf`);
        });
        this.isExporting = false;
        generatePdfCallback();

      });
  };

  createSmallPdf = (imgData, canvas) => {
    const { generatePdfCallback } = this.props;
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF({ orientation: 'landscape' });
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width; // total image height
    const position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    this.setState({
      isOpenLoader: false,
    }, () => {
      pdf.save(`${moment().format('_YYMMDD_HHmm')}.pdf`);
    });
    this.isExporting = false;
    generatePdfCallback();
  };

  createPdf = () => {
    const { refElement, viewMode } = this.state;
    const { generatePdfCallback } = this.props;
    if (this.isExporting) {
      return;
    }
    //this.setProgress(1);
    this.setState({
      isOpenLoader: true,
    });

    if (viewMode === 'card') {
      return this.createPdfWithCardView();
    }

    const refElementClientRect = refElement.getBoundingClientRect();
    const pageBreakEl = refElement.getElementsByClassName('page-break');

    if (pageBreakEl.length > 0) {
      let k = 0;
      for (k; k < pageBreakEl.length; k++) {
        const currentTableClientRect = pageBreakEl[k].getBoundingClientRect();

        if (k > 0) {
          const prevTableClientRect = pageBreakEl[k - 1].getBoundingClientRect();
          const firstBreakClientRect = pageBreakEl[0].getBoundingClientRect();
          const firstPageHeight = firstBreakClientRect.bottom - refElementClientRect.top;
          const realCanvasHeight = currentTableClientRect.bottom - prevTableClientRect.bottom;
          const currentElementHeigtht = (realCanvasHeight * 210) / firstPageHeight;

          const pad = this.createElement('div', {
            style: {
              display: 'block',
              height: `${210 - currentElementHeigtht}px`,
            }
          });
          pageBreakEl[k].parentNode.insertBefore(pad, pageBreakEl[k].nextSibling);
        }
      }
    }

    this.isExporting = true;

    html2canvas(refElement, { x: 0, y: 0 })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const elementTop = refElementClientRect.top;

        // eslint-disable-next-line new-cap
        const pdf = new jsPDF({ orientation: 'landscape' });
        const imgWidth = pdf.internal.pageSize.getWidth();
        //const pageHeight = 210;

        if (pageBreakEl.length === 0) {
          return this.createSmallPdf(imgData, canvas);
        }

        const clientRect = pageBreakEl[0].getBoundingClientRect();
        const currentImgHeight = clientRect.bottom - elementTop;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // total image height
        const pageHeight = (currentImgHeight * imgHeight) / canvas.height; // first image height

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        if (heightLeft >= 0) {
          let i = 1;
          for (i; i < pageBreakEl.length; i++) {
            const prevElementClientRect = pageBreakEl[i - 1].getBoundingClientRect();
            const currentElementClientRect = pageBreakEl[i].getBoundingClientRect();
            const pageBreakElImageHeight = currentElementClientRect.bottom - prevElementClientRect.bottom;
            const pageBreakElPageHeight = (pageBreakElImageHeight * imgHeight) / canvas.height;

            position = heightLeft - imgHeight;

            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageBreakElPageHeight;
          }
        }

        if (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        }

        this.setState({
          isOpenLoader: false,
        }, () => {
          pdf.save(`${moment().format('_YYMMDD_HHmm')}.pdf`);
        });
        this.isExporting = false;
        generatePdfCallback();
      });
  };

  createPdfWithListOnly = () => {
    const { refElement } = this.state;
    const { generatePdfCallback } = this.props;
    if (this.isExporting) {
      return;
    }
    //this.setProgress(1);
    this.setState({
      isOpenLoader: true,
    });

    const refElementClientRect = refElement.getBoundingClientRect();
    const pageBreakEl = refElement.getElementsByClassName('page-break');

    if (pageBreakEl.length > 0) {
      let k = 0;
      for (k; k < pageBreakEl.length; k++) {
        const pad = this.createElement('div', {
          style: {
            display: 'block',
            height: '65px', //50px
          }
        });
        pageBreakEl[k].parentNode.insertBefore(pad, pageBreakEl[k].nextSibling);
      }
    }

    this.isExporting = true;

    html2canvas(refElement, { x: 0, y: 0 })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const elementTop = refElementClientRect.top;

        // eslint-disable-next-line new-cap
        const pdf = new jsPDF({ orientation: 'landscape' });
        const imgWidth = pdf.internal.pageSize.getWidth();
        //const pageHeight = 210;

        if (pageBreakEl.length === 0) {
          return this.createSmallPdf(imgData, canvas);
        }

        const clientRect = pageBreakEl[0].getBoundingClientRect();
        const currentImgHeight = clientRect.bottom - elementTop;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // total image height
        const pageHeight = (currentImgHeight * imgHeight) / canvas.height; // first image height

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        if (heightLeft >= 0) {
          let i = 1;
          for (i; i < pageBreakEl.length; i++) {
            const prevElementClientRect = pageBreakEl[i - 1].getBoundingClientRect();
            const currentElementClientRect = pageBreakEl[i].getBoundingClientRect();
            const pageBreakElImageHeight = currentElementClientRect.bottom - prevElementClientRect.bottom;
            const pageBreakElPageHeight = (pageBreakElImageHeight * imgHeight) / canvas.height;

            position = heightLeft - imgHeight;

            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageBreakElPageHeight;
          }
        }

        if (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        }

        this.setState({
          isOpenLoader: false,
        }, () => {
          pdf.save(`${moment().format('_YYMMDD_HHmm')}.pdf`);
        });
        this.isExporting = false;
        generatePdfCallback();
      });
  };

  createPdfProjectView = () => {
    const { refElement, viewMode } = this.state;
    const { generatePdfCallback } = this.props;
    if (this.isExporting) {
      return;
    }
    //this.setProgress(1);
    this.setState({
      isOpenLoader: true,
    });

    if (viewMode === 'list') {
      return this.createPdfWithListOnly();
    }

    const refElementClientRect = refElement.getBoundingClientRect();
    const pageBreakEl = refElement.getElementsByClassName('page-break');

    if (pageBreakEl.length > 0) {
      let i = 0;
      for (i; i < pageBreakEl.length; i++) {
        const currentTableClientRect = pageBreakEl[i].getBoundingClientRect();

        if (i === 0) {
          const pad = this.createElement('div', {
            style: {
              display: 'block',
              height: '100px',
            }
          });
          pageBreakEl[i].parentNode.insertBefore(pad, pageBreakEl[i].nextSibling);
        } else {
          const prevTableClientRect = pageBreakEl[i - 1].getBoundingClientRect();
          const firstBreakClientRect = pageBreakEl[0].getBoundingClientRect();
          const firstPageHeight = firstBreakClientRect.bottom - refElementClientRect.top;
          const realCanvasHeight = currentTableClientRect.bottom - prevTableClientRect.bottom;
          const currentElementHeigtht = (realCanvasHeight * 160) / firstPageHeight;

          const pad = this.createElement('div', {
            style: {
              display: 'block',
              height: `${160 - currentElementHeigtht}px`,
            }
          });
          pageBreakEl[i].parentNode.insertBefore(pad, pageBreakEl[i].nextSibling);
        }
      }
    }

    //chartjs-render-monitor

    this.isExporting = true;
    html2canvas(refElement, { x: 0, y: 0, allowTaint: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        //const elementTop = refElementClientRect.top;

        if (pageBreakEl.length === 0) {
          return this.createSmallPdf(imgData, canvas);
        }

        // eslint-disable-next-line new-cap
        const pdf = new jsPDF({ orientation: 'landscape' });
        const imgWidth = pdf.internal.pageSize.getWidth();

        //const clientRect = pageBreakEl[0].getBoundingClientRect();
        //const currentImgHeight = clientRect.bottom - elementTop;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // total image height
        const pageHeight = 210;

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        if (heightLeft >= 0) {
          let i = 1;
          for (i; i < pageBreakEl.length; i++) {
            const prevElementClientRect = pageBreakEl[i - 1].getBoundingClientRect();
            const currentElementClientRect = pageBreakEl[i].getBoundingClientRect();
            const pageBreakElImageHeight = currentElementClientRect.bottom - prevElementClientRect.bottom;
            const pageBreakElPageHeight = (pageBreakElImageHeight * imgHeight) / canvas.height;

            position = heightLeft - imgHeight;

            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageBreakElPageHeight;
          }
        }

        if (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        }

        this.setState({
          isOpenLoader: false,
        }, () => {
          pdf.save(`${moment().format('_YYMMDD_HHmm')}.pdf`);
        });
        this.isExporting = false;
        generatePdfCallback();

      });
  };

  createElement(tagName, opt) {
    const el = document.createElement(tagName);
    if (opt.className) {
      el.className = opt.className;
    }
    if (opt.innerHTML) {
      el.innerHTML = opt.innerHTML;
      const scripts = el.getElementsByTagName('script');
      let i = scripts.length;
      for (i; i-- > 0; null) {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
    }
    const styleArray = Object.keys(opt.style);
    let j = 0;
    for (j; j < styleArray.length; j++) {
      el.style[styleArray[j]] = opt.style[styleArray[j]];
    }
    return el;
  }

  closeModal() {
    this.setState({
      isOpenLoader: false,
    });
  }

  render() {
    const {
      isOpenLoader,
      //creatingProgress,
    } = this.state;

    const {
      translate
    } = this.props;

    return (
      <div className="button_wrap util_item">
        <a
          className="gray_button util_button"
          style={{ cursor: 'pointer', padding: '7px', margin: '0' }}
          onClick={this.createElementWithCanvas}
          onKeyUp={this.createElementWithCanvas}
        >
          <Icon className="file pdf" style={{ margin: 0 }} />
        </a>
        <Modal
          open={isOpenLoader}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap export_data_wrap">
            <div className="modal_popup_box export_data_box">
              <div className="modal_popup export_data">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader
                    style={{
                      position: 'relative',
                      width: '80%',
                      height: '80%',
                      marginBottom: '15%',
                    }}
                  />
                  <span
                    style={{
                      fontWeight: '500',
                      fontSize: '16px',
                      marginTop: '35%',
                      display: 'inline-block',
                    }}
                  >
                    {translate('contents_header.message.prepare_report_download')}
                  </span>
                  {/**
                  <Segment>
                    <Progress
                      percent={creatingProgress}
                      progress="percent"
                      active={creatingProgress > 0 && creatingProgress < 100}
                      indicating
                    />
                  </Segment>
                   */}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(inject('state')(observer(ClarityReport)));
